// extracted by mini-css-extract-plugin
export default {"dialogContainer":"ProductCardDialog_dialogContainer__mgWZJ","dialogBackdrop":"ProductCardDialog_dialogBackdrop__QoFtB","button":"ProductCardDialog_button__75Qgm"};